export const HttpRequestExecutorToken = Symbol('HttpRequestExecutor');
export const BaseUrlFactoryToken = Symbol('BaseUrlFactory');
export const ErrorTrackerToken = Symbol('ErrorTracker');
